import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import { Button, Select, Space, Tag } from "antd";
import { useRef, useState } from "react";
import K from "utilities/constants";
import { CandidateFieldLabel } from "../candidateFieldLabel/candidateFieldLabel";
import labelStyles from "../candidateFieldLabel/candidateFieldLabel.module.scss";
import { CandidateFieldValue } from "../candidateFieldValue/candidateFieldValue";

export const CandidateSelectField = ({
  label,
  value,
  options = [],
  tagColor,
  selectProps,
  isEditable = false,
  disabled = false,
  onEdit,
  required = false,
}) => {
  const [isEdit, setIsEdit] = useState(false);
  const [validationError, setValidationError] = useState(null);
  const inputRef = useRef(value);

  const handleSave = () => {
    if (required && (inputRef.current == null || inputRef.current === "")) {
      setValidationError("This field is required.");
      return;
    }
    setValidationError(null);
    if (inputRef.current !== value) onEdit?.(inputRef.current);
    setIsEdit(false);
  };

  const handleCancel = () => {
    inputRef.current = value;
    setValidationError(null);
    setIsEdit(false);
  };

  const displayValue = () => {
    const name = options.find((o) => String(o.value) === String(value))?.label;
    if (!name) return K.NullPlaceholder;
    return tagColor ? <Tag color={tagColor}>{name}</Tag> : name;
  };

  if (isEdit) {
    return (
      <div>
        <CandidateFieldLabel required={required}>{label}</CandidateFieldLabel>
        <Select
          showSearch
          allowClear
          optionFilterProp="label"
          style={{ width: "100%" }}
          defaultValue={value}
          options={options}
          status={validationError ? "error" : undefined}
          onChange={(val) => {
            inputRef.current = val;
          }}
          {...selectProps}
        />
        {validationError && (
          <div className={labelStyles.errorMessage}>{validationError}</div>
        )}
        <div style={{ marginTop: 4 }}>
          <Button
            type="link"
            onClick={handleCancel}
            icon={<CloseCircleOutlined className="closeIcon" />}
          />
          <Button
            type="link"
            onClick={handleSave}
            icon={<CheckCircleOutlined className="checkIcon" />}
          />
        </div>
      </div>
    );
  }

  return (
    <div>
      <CandidateFieldLabel>{label}</CandidateFieldLabel>
      <Space size={4} style={{ minHeight: 24 }}>
        <CandidateFieldValue>{displayValue()}</CandidateFieldValue>
        {isEditable && !disabled && (
          <Button
            style={{ width: 16, height: 16 }}
            type="link"
            onClick={() => {
              inputRef.current = value;
              setIsEdit(true);
            }}
            icon={<i className="icon-edit" />}
          />
        )}
      </Space>
    </div>
  );
};
